import { CredentialRequestForm } from './CredentialRequestForm';
import { type SignInSession } from './sign-in-session.query';

export const ChatCredentialRequest = ({
  session,
  onBeforeSubmit,
}: {
  session: SignInSession | null | undefined;
  onBeforeSubmit?: () => void | Promise<void>;
}) => {
  return session ? (
    <CredentialRequestForm
      key={session.request?.input_request_id}
      request={session}
      onBeforeSubmit={onBeforeSubmit}
      overlay
    />
  ) : null;
};
